import React from 'react'
import { Button } from 'react-admin'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { useNavigate, useLocation } from 'react-router'
import { BackButtonProps } from './type'

const getPreviousPath = (pathname): string => {
  const previousPath = pathname.split('/')
  previousPath.pop()
  if (previousPath.length > 2) return `/${previousPath[1]}`
  return previousPath.join('/')
}

export const BackButton: React.FC<BackButtonProps> = ({ to = null, ...props }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const handleClick = (): void => {
    if (to) {
      navigate(to)
      return
    }
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1)
    } else {
      const previousPath = getPreviousPath(pathname)
      navigate(previousPath)
    }
  }
  return (
    <Button size='medium' onClick={handleClick} label='ra.action.back' {...props}>
      <ArrowBackRoundedIcon />
    </Button>
  )
}
